$(function(){
var  app_url='https://prod1.accumen.ahw2m.net/deathcertificate/';
var urlsms=window.location.href.split('?')[0];
var parts = urlsms.split('/');
var part1_sms = parts.pop();
var part2_sms = parts[parts.length - 1];
if (part1_sms == '') {
    var part1_sms = parts[parts.length - 1];
    var part2_sms = parts[parts.length - 2];
}
shop_url = Shopify.shop;
if (part1_sms == 'cart'){
   //$('.checkout-btn').prop("disabled", false);

  if ($('#discountqty').val() > 1) {
    $('.cart--additional-buttons.additional-checkout-buttons').hide();
  }
$( "body" ).on('submit', "form[action='/cart']", function(e){
    if ($('#discountqty').val() > 1) {
        e.preventDefault();

        $.ajax({
            url: "/cart.js?currency=usd",
            method: "GET",
            dataType: 'json',
            success: function(response) {
                if (response.items) {
                    if (response.item_count > 0) {

                        $.ajax({
                            type: 'POST',
                            url: app_url + "frontend/dorder",
                            data: {
                                shop: shop_url,
                                items: response
                            },
                            success: function(data) {
                                if (data) {
                                    
                                  setTimeout(function(){ location.href = data;}, 1000);
                                }
                            },
                        });

                    }
                }
            }
        });

    }
});
						
                 
}
  });